import { Form, Input, Checkbox } from "antd";
import { useThrottleFn } from "ahooks";

import { useEditorContext } from "../EditorContext";


export default () => {
  const [form] = Form.useForm();
  const { shareRefs } = useEditorContext();

  const { run: handleSettingChange } = useThrottleFn(
    (_, data) => {
      setTimeout(() => {
        form.validateFields().then(() => {
          shareRefs.updateRows(data);
        });

      });
    },
    { wait: 200 }
  );

  return (
    <Form
      form={form}
      initialValues={{
        ...shareRefs.tree.root.data,
      }}
      onFinish={(values) => {
        Object.assign(shareRefs.tree.root.data, values);
        handleSettingChange(null, values)
      }}
      onValuesChange={(val) => {
        Object.assign(shareRefs.tree.root.data, val);
        handleSettingChange(val);
      }}
      layout="vertical"
      style={{ marginLeft: 20, marginRight: 20 }}
    >
      <Form.Item label={"Page title"} name="pageTitle">
        <Input maxLength={100}/>
      </Form.Item>
      <Form.Item label={"Keywords"} name="metaKeywords">
        <Input maxLength={100}/>
      </Form.Item>
      <Form.Item label={"Description"} name="metaDescription">
        <Input maxLength={150}/>
      </Form.Item>
      <Form.Item name="metaNoFollow" valuePropName="checked">
        <Checkbox>Do not allow search engines to follow links on this page.</Checkbox>
      </Form.Item>
      <Form.Item name="metaNoIndex" valuePropName="checked">
        <Checkbox>Do not allow search engines to view this page.</Checkbox>
      </Form.Item>
      <Form.Item
        label={"Google Analytics ID"}
        name="googleAnalyticsID"
        tooltip={
          <span>
            Where to find your
            <a href="https://support.google.com/analytics/answer/9539598" target="_blank" rel="noreferrer" > Google Analytics ID?</a>
          </span>
        }
      >
        <Input maxLength={100}/>
      </Form.Item>
    </Form>
  );
};